<template>
  <div>
    <div ref="turnstile" id="cf-turnstile-box"></div>
    <HarmonyLoader v-if="loadingLocal" />
    <div class="page-background" v-if="!loadingLocal" role="main">
      <div class="background-layer" :style="getPageBackgroundStyle()"></div>
      <div class="background" :style="getBackgroundStyle()" :class="{ 'background-opacity': true }">
        <v-container class="mt-0 mb-0 fill-height">
          <v-row align="center" justify="center">
            <v-col class="col-12 col-md-7">
              <v-row no-gutters align="center" justify="center">
                <div class="rounded-xl card-shadow-logo relative" :class="[getBase('logo'), shapeClass]"
                  @click="editor ? $emit('edit-logo') : $emit('show-login', 'logo')">
                  <v-img v-if="usedHarmony && usedHarmony.logo_path" :src="usedHarmony.logo_path" max-width="100%"
                    max-height="100%" :class="[getBase('logo'), shapeClass]"
                    class="mt-0 px-0 mx-0 rounded-xl image-preview" loading="eager" fetchpriority="high" :width="'auto'"
                    :height="'auto'" :aspect-ratio="usedSiteSetting.profile.shape === 'rectangle' ? 1.5 : 1"
                    :alt="usedHarmony.name ? 'Foto de perfil de ' + usedHarmony.name : 'Foto de perfil'" />
                  <div v-else>
                    <v-icon v-if="editor" center color="#C9C9C9" size="40px"
                      class="mt-5 mt-md-8">mdi-pencil-box</v-icon>
                  </div>
                </div>

                <div class="col-12">
                  <h1 class="mt-1 title-harmony card-text-shadow">
                    <span :class="[getTitle()]" :style="{
                      color: usedSiteSetting.profile.title_color,
                      fontSize: usedSiteSetting.profile.title_font?.size ? usedSiteSetting.profile.title_font.size + 'px' : '32px',
                      fontWeight: usedSiteSetting.profile.title_font?.weight ? usedSiteSetting.profile.title_font.weight : '700'
                    }" @click="editor ? $emit('edit-title') : null">{{ formattedHarmonyName }}
                    </span>
                    <v-icon v-if="editor" center color="white" size="30px" class="mb-1"
                      @click="$emit('edit-title')">mdi-pencil-box</v-icon>
                  </h1>
                  <p v-if="usedHarmony.description" :style="getDescriptionStyle()" class="px-4 mb-2 mt-2">
                    <span :class="getTitle()" class="card-text-shadow responsive-text"
                      @click="editor ? $emit('edit-description') : null"
                      v-html="addLineBreaks(usedTranslatedDescription || usedHarmony.description)">
                    </span>
                    <v-icon v-if="editor" center color="white" size="30px" class="mb-1"
                      @click="$emit('edit-description')">mdi-pencil-box</v-icon>
                  </p>
                  <v-icon v-if="!usedHarmony.description && editor" center color="white" size="30px" class="mb-1"
                    @click="$emit('edit-description')">mdi-pencil-box</v-icon>
                </div>

                <template>
                  <component :is="usedSelectedLayout === 'grid' ? 'LayoutClassic' : 'LayoutBento'"
                    :cards="usedSiteSetting.platforms" :settings="usedSiteSetting" :isEditor="editor"
                    :userName="formattedHarmonyName"
                    :backendUrl="backendUrl" :incompleteConfigurations="usedIncompleteConf"
                    :shouldShowWppEmail="shouldShowWppEmail" :showSocials="showSocials"
                    :platformsAdult="platformsAdult"
                    @edit-card="handleEditCard"
                    @navigate-to-card="handleNavigateToCard"
                    @track-click="handleTrackClick"
                    @save-settings="() => { }" @add-card="$emit('add-card', $event)">
                    <template #socials>
                      <div id="socials" :class="[
                        countSocials() > 0 ? 'pl-2 pr-0 pr-md-0 py-0' : 'pa-0 d-flex justify-center align-center',
                        'card-shadow-socials', usedSelectedLayout === 'grid' ? 'rounded-xxl' : 'rounded-xl', getBase('socials', countSocials()),
                        { 'cursor': editor }
                      ]" @click="editor ? $emit('edit-socials') : null" v-if="showSocials" style="position: relative;">
                        <v-row no-gutters justify="center" v-if="countSocials() > 0">
                          <span v-for="(item, key) in usedSocials" :key="key" class="span-socials">
                            <a v-if="editor || item.nick != ''"
                              :href="editor ? undefined : formatSocialURL(item.name, item.nick)"
                              :target="editor ? undefined : '_blank'"
                              rel="noopener noreferrer"
                              @click="handleSocialClick($event, formatSocialURL(item.name, item.nick), item.name)"
                              class="mr-2 m-0 p-0"
                              :aria-label="item.name ? item.name + ' de ' + (usedHarmony.name || '') : key">
                              <div v-if="usedSiteSetting.style_socials == 'default'" class="my-2">
                                <div class="style-socials-default d-flex justify-center align-center"
                                  :class="getIconSize()">
                                  <img :src="getSocialIconLink(item.name)" :alt="item.name ? item.name + ' de ' + (usedHarmony.name || '') : key" loading="lazy" decoding="async">
                                </div>
                              </div>
                              <div v-if="typeof usedSiteSetting.style_socials == 'object'" class="my-2">
                                <div class="style-socials-personalized d-flex justify-center align-center"
                                  :class="getIconSize()"
                                  :style="{ background: '#' + styleSocial.color, borderRadius: (styleSocial.border * 1.4) + '%' }">
                                  <img :src="getSocialIconLink(item.name)" :alt="item.name ? item.name + ' de ' + (usedHarmony.name || '') : key" loading="lazy" decoding="async">
                                </div>
                              </div>
                              <img
                                v-if="usedSiteSetting.style_socials != 'default' && typeof usedSiteSetting.style_socials != 'object'"
                                :src="getIconPath(item.name)" class="socials-icon2 mt-2" :class="getIconSize()"
                                :alt="item.name ? item.name + ' de ' + (usedHarmony.name || '') : key" loading="lazy" decoding="async">
                            </a>
                          </span>
                        </v-row>
                        <v-icon v-if="editor && countSocials() == 0" center color="#C9C9C9"
                          size="40px" class="ma-auto">mdi-pencil-box</v-icon>
                      </div>
                    </template>

                    <template #wpp-email>
                      <div id="wpp-email" :class="{ 'ml-2': usedSelectedLayout === 'grid' }"
                        @click="editor ? $emit('edit-wpp-email') : null">
                        <v-expansion-panels>
                          <v-expansion-panel :style="getBackgroundStyleWpp()" class="rounded-lg mb-4">
                            <v-expansion-panel-header :icon-color="colorTextWpp"
                              style="font-size: 0.8375rem; font-weight: 600; padding: 16px 15px;">
                              <template v-slot:actions>
                                <v-icon :color="colorTextWpp">$expand</v-icon>
                              </template>
                              <p :style="{ color: colorTextWpp }" class="mb-0">{{ usedTranslatedText }}</p>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="expansion-content">
                              <v-select v-if="selectedOptionWpp === ''" :style="{ '--colorTextWpp': colorTextWpp }"
                                v-model="selectedOptionWpp" :items="['Email', 'WhatsApp']"
                                :label="usedTranslatedSelectText" :color="colorTextWpp" dark
                                class="select-gift mb-0 mt-0 pt-0">
                                <template v-slot:append>
                                  <v-icon :color="colorTextWpp">mdi-menu-down</v-icon>
                                </template>
                              </v-select>
                              <v-text-field v-if="selectedOptionWpp === 'Email'" :disabled="loadingWpp"
                                :loading="loadingWpp" v-model="email" :rules="[rulesWpp.required, rulesWpp.email]"
                                :color="colorTextWpp" class="pa-0 m-0 mb-2">
                                <template v-slot:append>
                                  <v-progress-circular v-if="loadingWpp" :color="colorTextWpp" :size="15" :width="1"
                                    indeterminate />
                                  <v-icon v-else @click="sendMessage(selectedOptionWpp)" size="15" :color="colorTextWpp"
                                    :disabled="!isValidEmail">
                                    mdi-send
                                  </v-icon>
                                </template>
                              </v-text-field>
                              <div v-else-if="selectedOptionWpp === 'WhatsApp'">
                                <v-row no-gutters>
                                  <v-col cols="4">
                                    <v-select v-model="phone_code" :items="phone_codes" item-text="dial_code"
                                      item-value="dial_code" :color="colorTextWpp" class="pa-0 m-0 mb-2"
                                      :disabled="loadingWpp" :loading="loadingWpp">
                                      <template v-slot:selection="{ item }">
                                        <v-avatar size="12"><img :src="item.flag" /></v-avatar>
                                        <span class="ml-1" style="font-size: 0.75rem;">{{ item.dial_code }}</span>
                                      </template>
                                      <template v-slot:item="{ item }">
                                        <v-avatar size="12"><img :src="item.flag" /></v-avatar>
                                        <span class="ml-1" style="font-size: 0.75rem;">{{ item.dial_code }}</span>
                                      </template>
                                    </v-select>
                                  </v-col>
                                  <v-col cols="8">
                                    <v-text-field :disabled="loadingWpp" :loading="loadingWpp" v-model="phone_number"
                                      :rules="[rulesWpp.required, rulesWpp.numericPhone, rulesWpp.minPhone, rulesWpp.maxPhone]"
                                      :color="colorTextWpp" class="pa-0 m-0 mb-2 ml-1">
                                      <template v-slot:append>
                                        <v-progress-circular v-if="loadingWpp" :color="colorTextWpp" :size="15"
                                          :width="1" indeterminate />
                                        <v-icon v-else @click="sendMessage(selectedOptionWpp)" size="15"
                                          :color="colorTextWpp" :disabled="!isValidWpp">
                                          mdi-send
                                        </v-icon>
                                      </template>
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </template>

                    <template #advertisement>
                      <Advertisement v-if="!isOwner && usedMonetize" :idHarmony="usedHarmony.id"
                        :idUser="usedHarmony.user_id" :siteName="usedHarmony.slug" :ageId="usedHarmony.age_id"
                        :genderId="usedHarmony.gender_id" :bodyId="usedHarmony.body_id"
                        :creatorTypeId="usedHarmony.creator_type_id" />
                    </template>
                  </component>
                </template>
              </v-row>
            </v-col>
            <ImageModal :mediaSrc="selectedMediaSrc" :mediaType="selectedMediaType" :isOpen.sync="isModalOpen" />
            <SensitiveContentModal
              :isOpen.sync="isSensitiveModalOpen"
              :description="sensitiveModalDesc"
              @confirm="handleSensitiveConfirmed"
            />
          </v-row>
        </v-container>
        <v-btn class="button-footer mb-10" rounded color="black" text x-medium aria-label="Ir a Harmony.fan">
          <a href="https://harmony.fan" target="_blank" class="a-footer" v-html="usedTranslatedFooterText"></a>
        </v-btn>
      </div>
      <v-row>
        <div class="section-statistics d-flex flex-column-reverse align-end">
          <HarmonyInteractions :harmonyId="usedHarmony.id" :initialLikes="usedLikes" :initialIsLiked="usedIsLiked"
            :initialIsFollowed="usedIsFollowed" :editor="editor" :isOwner="isOwner" @show-login="handleShowLogin" />

          <div class="item-section" v-if="usedVisits >= 1000 && !isOwner">
            <v-chip color="purple lighten-5" text-color="purple darken-2" small>
              <v-icon left small color="purple darken-2">mdi-eye</v-icon>
              {{ usedVisits.toLocaleString('es-CO') }}
            </v-chip>
          </div>
        </div>

        <LoginRegister v-model="login" :activity-log="activityLog" @login-success="handleLoginSuccess"
          @register-success="handleRegisterSuccess" @login-closed="handleLoginClosed" />

        <v-tooltip right color="#8e84c0" v-if="!isOwner">
          <template v-slot:activator="{ on, attrs }">
            <div class="harmony-button" v-bind="attrs" v-on="on" @click="openHome">
              <img src="../../assets/logo/1-10.webp" width="53" height="53" loading="lazy" decoding="async" alt="Harmony Logo" />
            </div>
          </template>
          <span>¡Crea tu harmony!</span>
        </v-tooltip>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from '@/axios.js'
import { SOCIAL_BASE_URLS } from '@/config/harmony/socials'
import socialUrlFormatter from '@/mixins/harmony/socialUrlFormatter'
import analyticsMixin from '@/mixins/harmony/analyticsMixin'
import adultMixin from '@/mixins/harmony/adultMixin'
import backgroundMixin from '@/mixins/harmony/backgroundMixin'
import descriptionMixin from '@/mixins/harmony/descriptionMixin'
import socialMixin from '@/mixins/harmony/socialMixin'
import { loadHarmonyData, getPhoneCodesCached } from './harmonyLoader'
import { createDefaultSiteSetting, normalizeSiteSetting } from './siteState'
import { loadTurnstile } from '@/utils/turnstileLoader'

export default {
  name: 'HarmonyPublic',
  mixins: [socialUrlFormatter, analyticsMixin, adultMixin, backgroundMixin, descriptionMixin, socialMixin],
  components: {
    ImageModal: () => import('@/components/harmony/uploads/extra/ImageModal.vue'),
    SensitiveContentModal: () => import('@/components/harmony/dialogs/SensitiveContentModal.vue'),
    LoginRegister: () => import('@/components/auth/LoginRegister.vue'),
    HarmonyInteractions: () => import('@/components/harmony/HarmonyInteractions.vue'),
    HarmonyLoader: () => import('@/components/harmony/HarmonyLoader.vue'),
    LayoutClassic: () => import('@/components/harmony/Layouts/LayoutClassic.vue'),
    LayoutBento: () => import('@/components/harmony/Layouts/LayoutBento.vue'),
    Advertisement: () => import('@/components/harmony/uploads/extra/Advertisement.vue'),
  },
  props: {
    site_setting: { type: Object, default: null },
    harmony: { type: Object, default: null },
    socials: { type: Array, default: () => [] },
    monetize: { type: Boolean, default: false },
    isOwner: { type: Boolean, default: false },
    likes: { type: Number, default: 0 },
    isLiked: { type: Boolean, default: false },
    isFollowed: { type: Boolean, default: false },
    visits: { type: Number, default: 0 },
    translatedText: { type: String, default: '' },
    translatedSelectText: { type: String, default: '' },
    translatedDescription: { type: String, default: '' },
    translatedFooterText: { type: String, default: '' },
    selectedLayout: { type: String, default: 'grid' },
    backendUrl: { type: String, default: 'https://backend.harmony.fan/storage' },
    incompleteConf: { type: Array, default: () => [] },
    styleSocial: { type: Object, default: () => ({ color: '000', border: 12 }) },
    colorTextWpp: { type: String, default: '' },
    editor: { type: Boolean, default: false },
  },
  data() {
    return {
      widgetId: null,
      loadingLocal: true,
      is_user_adult: false,
      login: false,
      loginLoading: false,
      loginUser: '',
      show1: false,
      first_name: '',
      last_name: '',
      password: '',
      password_confirm: '',
      register: false,
      registerLoading: false,
      userType: [],
      loadingUserType: false,
      role_id: 3,
      activityLog: '',
      email: '',
      loadingWpp: false,
      selectedOptionWpp: '',
      phone_codes: null,
      phone_code: '(+57)',
      phone_number: '',
      socialBaseUrls: SOCIAL_BASE_URLS,
      platformsAdult: [],
      localSiteSetting: null,
      rulesWpp: {
        required: value => !!value || 'Required',
        minPhone: v => v.length >= 6 || 'Min 6 characters',
        maxPhone: v => v.length <= 12 || 'Max 12 characters',
        numericPhone: v => /^[0-9]+$/.test(v) || 'Only numbers',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid email'
        }
      },
      localHarmony: null,
      localSocials: [],
      localMonetize: false,
      localLikes: 0,
      localIsLiked: false,
      localIsFollowed: false,
      localVisits: 0,
      localTranslatedText: '',
      localTranslatedSelectText: '',
      localTranslatedDescription: '',
      localTranslatedFooterText: '',
      localSelectedLayout: 'grid',
      localIncompleteConf: [],
      defaultSocials: [
        { name: 'instagram', nick: '' },
        { name: 'facebook', nick: '' },
        { name: 'tiktok', nick: '' }
      ],
    }
  },
  computed: {
    usedHarmony() { return this.harmony || this.localHarmony || {} },
    usedSiteSetting() {
      if (this.harmony && this.harmony.id) {
        return normalizeSiteSetting(this.site_setting)
      }
      return normalizeSiteSetting(this.localSiteSetting)
    },
    formattedHarmonyName() {
      const name = this.usedHarmony?.name || ''
      if (!name) return ''
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    usedMonetize() { return this.harmony ? this.monetize : this.localMonetize },
    usedLikes() { return this.harmony ? this.likes : this.localLikes },
    usedIsLiked() { return this.harmony ? this.isLiked : this.localIsLiked },
    usedIsFollowed() { return this.harmony ? this.isFollowed : this.localIsFollowed },
    usedVisits() { return this.harmony ? this.visits : this.localVisits },
    usedTranslatedText() { return this.harmony ? this.translatedText : this.localTranslatedText },
    usedTranslatedSelectText() { return this.harmony ? this.translatedSelectText : this.localTranslatedSelectText },
    usedTranslatedDescription() { return this.harmony ? this.translatedDescription : this.localTranslatedDescription },
    usedTranslatedFooterText() { return this.harmony ? this.translatedFooterText : this.localTranslatedFooterText },
    usedSelectedLayout() { return this.harmony ? this.selectedLayout : this.localSelectedLayout },
    usedIncompleteConf() { return this.harmony ? this.incompleteConf : this.localIncompleteConf },
    usedSocials() { return this.harmony?.id ? this.socials : (this.localSocials || []) },
    shapeClass() {
      const s = this.usedSiteSetting?.profile?.shape
      if (s === 'rectangle') return 'logo-rectangle'
      if (s === 'circle') return 'rounded-circle'
      return 'rounded-xl'
    },
    shouldShowWppEmail() {
      return true
    },
    showSocials() {
      if (this.editor) return true
      return this.socialItems.some(social => social.nick && social.nick.trim() !== '')
    },
    socialItems() {
      return this.countSocials && this.countSocials() > 0 ? this.usedSocials : this.defaultSocials
    },
    isValidEmail() {
      return this.rulesWpp?.required?.(this.email) === true &&
        this.rulesWpp?.email?.(this.email) === true
    },
    isValidWpp() {
      return this.rulesWpp?.required?.(this.phone_code) === true &&
        this.rulesWpp?.required?.(this.phone_number) === true &&
        this.rulesWpp?.numericPhone?.(this.phone_number) === true &&
        this.rulesWpp?.minPhone?.(this.phone_number) === true &&
        this.rulesWpp?.maxPhone?.(this.phone_number) === true
    },
  },
  metaInfo() {
    if (this.editor) return {}
    const harmony = this.usedHarmony || {}
    const defaultImage = 'https://backend.harmony.fan/storage/images/harmony.png'
    const rawName = harmony.name || this.$route?.params?.slug || ''
    const name = rawName
      ? rawName.charAt(0).toUpperCase() + rawName.slice(1)
      : 'Harmony Fan'
    const description = harmony.description || 'Harmony fan es una herramienta que te permite con un solo Clic conectar tu audiencia con tus plataformas y ganar dinero al hacerlo.'

    return {
      titleTemplate: '%s - Harmony Fan',
      title: name,
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        { name: 'description', content: description },
        { property: 'og:title', content: name },
        { property: 'og:description', content: description },
        { property: 'og:image', content: harmony.logo_path || defaultImage },
        { property: 'og:url', content: harmony.slug ? `https://harmony.fan/${harmony.slug}` : 'https://harmony.fan/' },
        { name: 'twitter:title', content: name },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: harmony.logo_path || defaultImage },
        { name: 'twitter:card', content: 'summary_large_image' }
      ]
    }
  },
  async created() {
    if (this.editor || (this.harmony && this.harmony.id)) {
      this.loadingLocal = false
      return
    }
    const slug = this.$route.params.slug
    if (!slug) {
      this.loadingLocal = false
      return
    }
    try {
      const data = await loadHarmonyData(slug)
      if (!data || !data.harmony) {
        if (!this.editor) {
          this.$router.replace({ name: 'NotFound' })
        }
        return
      }

      this.localHarmony = data.harmony
      this.localSiteSetting = data.settings || createDefaultSiteSetting()
      this.localVisits = data.visits
      this.localLikes = data.likes
      this.localIsLiked = data.isLiked
      this.localIsFollowed = data.isFollowed
      this.localMonetize = data.monetize
      this.localTranslatedText = data.translatedText
      this.localTranslatedSelectText = data.translatedSelectText
      this.localTranslatedDescription = data.translatedDescription
      this.localTranslatedFooterText = data.translatedFooterText
      this.localSocials = this.localHarmony.site_settings?.socials || []
      this.localSelectedLayout = this.localHarmony.site_settings?.layout?.name || 'grid'
      this.localIncompleteConf = []

      // Check status_id if not owner
      if (this.localHarmony.status_id != 3 && !this.localHarmony.owner && !this.editor) {
        const user = JSON.parse(localStorage.getItem('user')) || {}
        if (user.id !== this.localHarmony.user_id) {
          this.$router.replace({ name: 'NotFound' })
          return
        }
      }

      // Verificar redirección de adultos ANTES de ocultar el loader y mostrar el contenido
      if (!this.isOwner && !this.editor) {
        const isAdult = this.localHarmony.creator_type_id == 1
        const isRedirecting = this.checkUserAdultRedirect(isAdult, this.localHarmony.slug)
        if (isRedirecting) {
          // Si está redirigiendo, mantener el loader activo (sin pintar el perfil) y detener la ejecución
          return
        }
      }

      // Ocultar loader para que el visitante verificado vea el perfil
      this.loadingLocal = false

      this.setLanguage()
      this.getPhoneCodes()
      this.getPlatformsAdult() // Non-blocking: background cached call

      if (!this.editor && !this.isOwner) {
        this.scheduleRegisterVisit()
      }
    } catch (error) {
      console.error('Error loading harmony:', error)
      if (!this.editor) {
        this.$router.replace({ name: 'NotFound' })
      } else {
        this.loadingLocal = false
      }
    }
  },
  methods: {
    getTitle() { return '' },
    getBase(value) {
      const h = this.usedHarmony
      if (value === 'logo') {
        return h && h.logo_path ? 'logo2' : 'logo-white'
      }
      if (value === 'socials') {
        return 'socials base-socials'
      }
      return ''
    },
    addLineBreaks(text) {
      return text ? text.replace(/\n/g, '<br>') : ''
    },
    openHome() {
      window.open('/', '_blank')
    },
    handleShowLogin(activity) {
      this.activityLog = activity
      this.login = true
    },
    handleLoginSuccess() {
      this.login = false
      this.$emit('login-success')
    },
    handleLoginClosed() {
      this.login = false
    },
    handleRegisterSuccess() {
      this.register = false
      this.$emit('register-success')
    },
    handleEditCard({ cardNumber, platformName }) {
      if (this.editor) {
        this.$emit('edit-card', { cardNumber, platformName })
      }
    },
    handleNavigateToCard({ card, src }) {
      if (this.harmony && this.harmony.id) {
        this.$emit('navigate-to-card', { card, src })
      } else {
        this.navigateToCard(card, src)
      }
    },
    handleTrackClick({ url, platform }) {
      this.trackCardClick(url, platform)
    },
    handleSocialClick(event, url, platform) {
      if (this.editor) {
        if (event) event.preventDefault()
        return
      }
      this.trackCardClick(url, platform)
    },
    likeSite() {
      this.$emit('like')
    },
    followHarmony() {
      this.$emit('follow')
    },
    async getTokenCloudflare() {
      try {
        const turnstile = await loadTurnstile()
        if (!turnstile || typeof turnstile.render !== 'function' || !this.$refs.turnstile) {
          return null
        }
        return new Promise((resolve) => {
          const timeout = setTimeout(() => {
            resolve(null)
          }, 3500)

          try {
            if (this.widgetId && typeof turnstile.remove === 'function') {
              try {
                turnstile.remove(this.widgetId)
              } catch (e) {
                // Ignore removal errors
              }
              this.widgetId = null
            }
            if (this.$refs.turnstile) {
              this.$refs.turnstile.innerHTML = ''
            }

            this.widgetId = turnstile.render(
              this.$refs.turnstile,
              {
                sitekey: '0x4AAAAAABbWOJ_t8X7HYmoE',
                callback: (tok) => {
                  clearTimeout(timeout)
                  resolve(tok)
                },
                'error-callback': () => {
                  clearTimeout(timeout)
                  resolve(null)
                }
              }
            )
          } catch (renderError) {
            clearTimeout(timeout)
            console.error('Turnstile render error:', renderError)
            resolve(null)
          }
        })
      } catch (err) {
        console.error('Error loading Turnstile:', err)
        return null
      }
    },
    scheduleRegisterVisit() {
      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        window.requestIdleCallback(() => {
          this.registerVisit()
        }, { timeout: 2000 })
      } else {
        setTimeout(() => {
          this.registerVisit()
        }, 1000)
      }
    },
    async registerVisit() {
      if (this.editor || this.isOwner) return
      let visitorId = localStorage.getItem('visitorId')
      let components = null

      try {
        const FingerprintJS = await import(
          /* webpackChunkName: "fingerprint" */
          '@fingerprintjs/fingerprintjs'
        )
        const fp = await FingerprintJS.load()
        const result = await fp.get()
        visitorId = result.visitorId
        components = result.components
        localStorage.setItem('visitorId', visitorId)
      } catch (error) {
        console.error('Fingerprint error:', error)
      }

      let token = null
      try {
        token = await this.getTokenCloudflare()
      } catch (err) {
        // Proceed even if Turnstile fails
      }

      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        await axios.post('/register-visit', {
          site_id: this.usedHarmony.id,
          user_id: this.usedHarmony.user_id,
          fingerprint: visitorId,
          user_agent: navigator.userAgent,
          language: navigator.language,
          timezone: timezone,
          platform: navigator?.userAgentData?.platform || navigator?.platform,
          screen_resolution: typeof screen !== 'undefined' ? `${screen.width}x${screen.height}` : '',
          webgl_vendor: components?.webGlBasics?.value || null,
          audio_hash: components?.audio?.value || null,
          token_cloudflare: token,
        })
      } catch (error) {
        console.error('Error registering visit:', error)
      }
    },
    getIncompleteConfigurations() {
      // handled by editor
    },
    countSocials() {
      return this.usedSocials.length
    },
    getPageBackgroundStyle() {
      const ss = this.usedSiteSetting
      if (ss.page?.background) {
        return {
          backgroundImage: `url(${ss.page.background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          top: '0',
          left: '0',
          width: '100%',
          zIndex: '0',
        }
      }
      return {}
    },
    getBackgroundStyle() {
      const ss = this.usedSiteSetting
      let backgroundImage = ''
      const oldPatterns = ["estrellas", "lunas", "ondas", "happyface", "flor2", "flor", "cuadros", "corazones", "calavazas", "calaberas", "puntos", "play"]
      const pattern = ss.page?.pattern
      if (pattern) {
        backgroundImage = `https://backend.harmony.fan/storage/backgrounds2/${pattern}.png?v=5`
      }
      if (ss.page?.background) {
        return { backgroundImage: `url(${backgroundImage})` }
      }
      const useOldPattern = oldPatterns.includes(pattern)
      const styleProperties = useOldPattern ? { backgroundSize: 'cover' } : {}
      if (typeof ss.page?.color === 'string') {
        return {
          background: `${backgroundImage ? `url(${backgroundImage}), ` : ''}${ss.page.color}`,
          ...styleProperties
        }
      }
      const colorSettings = ss.page?.color || {}
      return {
        background: `${backgroundImage ? `url(${backgroundImage}), ` : ''}linear-gradient(${colorSettings.direction || 'to top'}, ${colorSettings.color1 || '#D4D4D4'}, ${colorSettings.color2 || '#D4D4D4'})`,
        ...styleProperties
      }
    },
    getBackgroundStyleWpp() {
      const ss = this.usedSiteSetting
      const bg = ss.wppOrEmail?.background || {}
      return {
        background: `linear-gradient(${bg.direction || 'to top'}, ${bg.color1 || '#FF00FF00'}, ${bg.color2 || '#FF00FF00'})`,
        backgroundSize: 'cover',
      }
    },
    getIconPath(social) {
      return `https://backend.harmony.fan/storage/socials/${this.usedSiteSetting.style_socials}/${social}.svg`
    },
    getDescriptionStyle() {
      const ss = this.usedSiteSetting
      if (ss?.profile?.description_style) {
        const style = ss.profile.description_style
        const formats = style.formats || []
        const alignment = style.alignment || 'center'
        let styles = {}
        if (formats.includes('bold')) styles.fontWeight = 'bold'
        if (formats.includes('italic')) styles.fontStyle = 'italic'
        if (formats.includes('underline')) styles.textDecoration = 'underline'
        styles.textAlign = alignment
        return styles
      }
      return { textAlign: 'center' }
    },
    async sendMessage(type) {
      let data
      if (type === 'WhatsApp') {
        data = {
          phone_code: this.phone_code,
          phone_number: this.phone_number,
          site_id: this.usedHarmony.id,
          type: type
        }
      } else {
        data = {
          email: this.email,
          site_id: this.usedHarmony.id,
          type: type
        }
      }
      this.loadingWpp = true
      try {
        const response = await axios.post('send-wpp-email', data)
        if (response.data.success) {
          this.phone_number = ''
          this.email = ''
          this.selectedOptionWpp = ''
        }
      } catch (error) {
        console.error(error)
      }
      this.loadingWpp = false
    },
    async getPhoneCodes() {
      try {
        this.phone_codes = await getPhoneCodesCached()
      } catch (error) {
        console.error(error)
      }
    },
    setLanguage() {
      const storedLocale = localStorage.getItem('locale')
      if (storedLocale) {
        this.$i18n.locale = storedLocale
      } else {
        this.$i18n.locale = 'es'
      }
    },
  }
}
</script>

<style scoped>
.page-background {
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.background {
  position: relative;
  z-index: 1;
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
  min-height: 100vh;
}

.background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
  opacity: 0.5;
  z-index: -1;
  width: 100%;
}

.background-opacity::before {
  opacity: 0.5;
}

.background-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  backface-visibility: hidden;
}

.harmony-button {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 90;
  cursor: pointer;
  transition: 2s;
}

.harmony-button img {
  width: 30px;
  height: auto;
  object-fit: contain;
}

@media (width <=600px) {
  .harmony-button img {
    width: 30px !important;
    height: auto !important;
  }
}

.section-statistics {
  position: fixed;
  top: 14px;
  width: 100%;
  z-index: 90;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.item-section {
  font-size: 20px;
  width: fit-content;
  margin-left: 4px;
}

.logo-rectangle {
  width: 180px !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.responsive-text {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  font-size: 1rem;
}

@media (max-width: 354px) {
  .responsive-text {
    font-size: 0.875rem;
    line-height: 1.2;
  }
}

.card-text-shadow {
  text-shadow: #00000054 0px 0px 5px;
}

.card-shadow-logo {
  box-shadow: #878282 0px 1px 6px 0.1px;
}

.card-shadow-socials {
  box-shadow: #0000002b 0px 1px 10px 1.3px;
}

.button-footer {
  background-color: #ffffff;
  font-size: 11px;
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

@media (min-width: 321px) and (max-width: 400px) {
  .button-footer {
    font-size: 0.6rem;
    padding: 0.4rem;
  }
}

@media (max-width: 320px) and (min-width: 100px) {
  .button-footer {
    font-size: 0.5rem;
    padding: 0.2rem;
  }
}

.a-footer {
  color: inherit;
  text-decoration: none;
}

.base-socials {
  background-color: white;
}

.base-socials-editor {
  cursor: pointer;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 48px;
}

.socials-icon2 {
  width: 40px;
}

.icon-size-smallest {
  width: 35px !important;
  height: 35px !important;
}

.icon-size-small {
  width: 30px !important;
  height: 30px !important;
}

.icon-size-medium {
  width: 34px !important;
  height: 34px !important;
}

.icon-size-large {
  width: 40px !important;
  height: 40px !important;
}

@media(width >=960px) {
  .icon-size-medium {
    width: 50px !important;
    height: 50px !important;
  }

  .icon-size-small {
    width: 50px !important;
    height: 50px !important;
  }

  .icon-size-large {
    width: 50px !important;
    height: 50px !important;
  }

  .icon-size-smallest {
    width: 40px !important;
    height: 40px !important;
  }
}

@media (width > 430px) and (width < 959px) {
  .icon-size-medium {
    width: 50px !important;
    height: 50px !important;
  }

  .icon-size-small {
    width: 35px !important;
    height: 35px !important;
  }
}

@media (width <=350px) {
  .icon-size-medium {
    width: 28px !important;
  }

  .icon-size-small {
    width: 30px !important;
  }
}

.socials {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60px;
}

.logo {
  cursor: pointer;
  height: 100px;
  width: 100px;
  background-color: #E8E8E8;
}

.logo2 {
  height: 100px;
  width: 100px;
}

.logo-white {
  height: 100px;
  width: 100px;
  background-color: #FFFFFF;
}

.logo .v-img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.base {
  cursor: pointer;
}

.base2 {
  cursor: pointer;
}

@media (max-width: 959px) {
  .socials-icon2 {
    width: 30px;
  }

  .logo {
    height: 90px;
    width: 90px;
  }

  .title-harmony {
    font-size: 26px;
  }
}

@media (max-width: 496px) {
  .socials-icon2 {
    width: 27px;
  }
}

@media (max-width: 400px) {
  .socials-icon2 {
    width: 24px;
  }
}

.style-socials {
  width: 24px;
  height: 24px;
}

.style-socials img {
  max-width: 14px;
  max-height: 14px;
}

.style-socials-personalized {
  width: 40px;
  height: 40px;
}

.style-socials-personalized img {
  max-width: 65%;
  max-height: 65%;
}

.style-socials-default {
  width: 40px;
  height: 40px;
}

.style-socials-default img {
  max-width: 85%;
  max-height: 85%;
}

.span-socials {
  max-height: fit-content !important;
  display: flex;
}

.font-anton {
  font-family: 'Anton', sans-serif;
}

.font-bebas-neue {
  font-family: 'Bebas Neue', sans-serif;
}

.font-bree-serif {
  font-family: 'Bree Serif', serif;
}

.font-caveat {
  font-family: 'Caveat', cursive;
}

.font-concert-one {
  font-family: 'Concert One', cursive;
}

.font-courgette {
  font-family: 'Courgette', cursive;
}

.font-creepster {
  font-family: 'Creepster', cursive;
}

.font-dancing-script {
  font-family: 'Dancing Script', cursive;
}

.font-fira-sans-condensed {
  font-family: 'Fira Sans Condensed', sans-serif;
}

.font-indie-flower {
  font-family: 'Indie Flower', cursive;
}

.font-jockey-one {
  font-family: 'Jockey One', sans-serif;
}

.font-orbitron {
  font-family: 'Orbitron', sans-serif;
}

.font-oswald {
  font-family: 'Oswald', sans-serif;
}

.font-pacifico {
  font-family: 'Pacifico', cursive;
}

.font-permanent-marker {
  font-family: 'Permanent Marker', cursive;
}

.font-pixelify-sans {
  font-family: 'Pixelify Sans', sans-serif;
}

.font-protest-strike {
  font-family: 'Protest Strike', cursive;
}

.font-roboto {
  font-family: 'Roboto', sans-serif;
}

.font-teko {
  font-family: 'Teko', sans-serif;
}

.font-titillium-web {
  font-family: 'Titillium Web', sans-serif;
}

.font-rubik {
  font-family: 'Rubik', sans-serif;
}

body {
  margin: 0;
  overflow: hidden;
}

.cursor {
  cursor: pointer;
}
</style>
